import React from 'react';
import { useTranslation } from 'react-i18next';
import { PrivacySectionContent, PrivacySection } from '../components/PrivacyContent';
import '../styles/LegalPages.css';

const PrivacyPolicyPage: React.FC = () => {
  const { t } = useTranslation();

  const sections = t('privacyPolicy.sections', { returnObjects: true }) as PrivacySection[];
  const footerNote = t('privacyPolicy.footerNote');

  // Check if sections is valid
  if (!sections || !Array.isArray(sections)) {
    return (
      <div className="main-wrapper">
        <div className="section-hero-banar is-services">
          <div className="padding-global">
            <div className="container-large">
              <div className="padding-section-medium">
                <h2 className="heading-style-h2">Loading...</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-wrapper">
      {/* Hero Banner */}
      <div className="section-hero-banar is-beta-invite">
        <div className="padding-global">
          <div className="container-large">
            <div className="padding-section-medium">
              <div className="hero-banner-component">
                <div className="hero-banner-content-wrapper">
                  <h2 className="heading-style-h2">{t('privacyPolicy.title')}</h2>
                  <div className="hero-banar-content">
                    <span className="home-link">{t('privacyPolicy.lastUpdated')}: {t('privacyPolicy.updateDate')} | {t('privacyPolicy.effectiveDate')}: {t('privacyPolicy.effectiveDateValue')}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="section-style-guide">
        <div className="padding-global">
          <div className="container-large">
            <div className="padding-section-large">
              {/* Privacy Policy Content - Full Width */}
              <div className="style-guide-content-wrapper" style={{ maxWidth: '900px', margin: '0 auto' }}>
                <div className="padding-section-medium">
                  {/* Introduction */}
                  <div className="note-wrapper">
                    <p>{t('privacyPolicy.introduction')}</p>
                  </div>
                  <div className="margin-bottom margin-large"></div>

                  {/* Privacy Sections */}
                  {sections.map((section, index) => (
                    <div key={index} className="privacy-section">
                      <div className="margin-bottom margin-xsmall">
                        <h4 className="heading-style-h4">{section.title}</h4>
                      </div>
                      <PrivacySectionContent blocks={section.blocks || []} />
                    </div>
                  ))}

                  {/* Footer Note */}
                  {footerNote && <p className="tos-footer-note">{footerNote}</p>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
